import React from 'react';
import { ru } from './messages/ru.js';
import { en } from './messages/en.js';
import { useLanguage } from './Language.js';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const pick = (object, path) => path.split('.').reduce((o, k) => (o || {})[k], object);
const useTranslation = () => {
    const lang = useLanguage('useTranslation');
    const schema = { ru, en }[lang];
    return React.useCallback((path) => pick(schema, path), [schema]);
};

export { useTranslation };
//# sourceMappingURL=useTranslation.js.map
